import React from 'react';
import styled from 'styled-components';

import { CurrentTheme, StringUtils, MagstimLoadingSpinner, CurrentLang } from "common";
import { Row, Col, InputGroup, Label, Input, Button } from 'reactstrap';

import styledMagstimTabsWrapper from 'common/controls/StyledMagstimTabsWrapper'
import PatientInformationCard from '../views/Patient/PatientProfile/PatientInformationCard';

import { accuracyRoute, mtHistoryRoute, assessmentsRoute, treatmentsRoute, reportRoute } from 'routes';

const AUTO_COMPLETE_OFF = 'off';

class MagstimAnalyticsSearchBase extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            buttonsDisabled: true,
            tableHeight: '',
            selectedItems: [],
            privacyOn: true,
            tableClassType: undefined,
            pageAnalyticsName: '',
            pageBaseRoute: ''
        };

        this._table = React.createRef();
        this._searchInput = React.createRef();
    }

    selectedObjects(){

        var selectedObjects = [];
        
        this.state.selectedItems.forEach(function (item) {
            selectedObjects.push(item.object)
        });

        return selectedObjects;
    }

    selectedGuids(){

        const selectedGuids = [];
        
        this.state.selectedItems.forEach(function (item) {
            selectedGuids.push(item.guid)
        });

        return selectedGuids;
    }

    tableAreaTitle() {
        return StringUtils.format(CurrentLang().search_title,  [this.state.pageAnalyticsName])
    }

    buttonAreaTitle() {
        return StringUtils.format(CurrentLang().analytics_title,  [this.state.pageAnalyticsName])
    }

    searchSelectHelp() {
        return StringUtils.format(CurrentLang().search_select_help, [this.state.pageAnalyticsName.toLowerCase()]);
    }

    searchAnalyticsHelp() {
        // TODO: Adding the 's' works for the strings we have and the languages we currently use...
        if (this.state.selectedItems.length > 1) {
            return StringUtils.format(CurrentLang().search_analytics_help, [this.state.pageAnalyticsName.toLowerCase() + 's']);
        } else {
            return StringUtils.format(CurrentLang().search_analytics_help, [this.state.pageAnalyticsName.toLowerCase()]);
        }
    }

    onShowAccuracy = () => {
        this.props.history.push({
            pathname: `${this.state.pageBaseRoute}/${accuracyRoute}`,
            state: { Guids: this.selectedGuids() }
        })
    }

    onShowAssessments = () => {
        this.props.history.push({
            pathname: `${this.state.pageBaseRoute}/${assessmentsRoute}`,
            state: { Guids: this.selectedGuids() }
        })
    }

    onShowMTHistory = () => {
        this.props.history.push({
            pathname: `${this.state.pageBaseRoute}/${mtHistoryRoute}`,
            state: { Guids: this.selectedGuids() }
        })
    }

    onShowTreatments = () => {
        this.props.history.push({
            pathname: `${this.state.pageBaseRoute}/${treatmentsRoute}`,
            state: { Guids: this.selectedGuids() }
        })
    }

    onShowReport = () => {
        this.props.history.push({
            pathname: `${this.state.pageBaseRoute}/${reportRoute}`,
            state: { Guids: this.selectedGuids() }
        })
    }

    init(data) {
        // console.log('init', userData);
        if (this._table.current !== undefined && this._table.current !== null) {
            this._table.current.initForSelect(data);
            this._table.current.resetFilters(null); // no Status filtering by default
        }
    }

    onFocus = event => {
        if (event.target.autocomplete) event.target.autocomplete = AUTO_COMPLETE_OFF;
    };

    onClearSearch = () => {
        if (this._table.current !== undefined && this._table.current !== null) {
            // Clear the table search 
            this._searchInput.current.value = "";
            this._table.current.search();
        }
    }

    onSearchChange = (text) => {
        if (this._table.current !== undefined && this._table.current !== null) {
            this._table.current.search(text);
        }
    }

    onSelectionCleared = () => {
        console.log(`onSelectionCleared`);
        this.setState({selectedItems:[]});
    }

    getSelectedItemsDetails = () => {

        // Setup
        var details = '';
        const maxLength = 200;
        const numberOfUsers = this.selectedObjects().length;
        var count = 0;
        var listComplete = false;
        const privacyOn = this.state.privacyOn;
        const getSelectedItemDetail = this.getSelectedItemDetail;

        // Iterate
        this.selectedObjects().forEach(function (item) {

            if (listComplete === false) {
                if (details.length <= maxLength) {
                    // Append each user name with a comma
                    details = `${details}  ${getSelectedItemDetail(privacyOn, item)}, `;
                    count++;
                }
                else {
                    // Once over length add the read as a plus x
                    const usersLeft = numberOfUsers - count;
                    details = `${details} ${CurrentLang().plus} ${usersLeft} ${CurrentLang().more}, `;
                    listComplete = true;
                }
            }
        });

        // Trim and add a full stop if needed
        if (details.length > 2) {
            details = details.substring(0, details.length - 2);
            details = `${details}.`;
        }

        return details;
    }

    selectionChangedCallback = (event, isSelected, rows, row) => {
        if (rows !== null && rows !== undefined) {

            // Get the currently selected items
            var itemSelected = false;
            var selectedItems = this.state.selectedItems;

            // Add or remove the changes ones 
            rows.forEach(row => {

                const newItemGUID = this.getGuidFromRow(row);
                const itemIndex =  selectedItems.findIndex(element => newItemGUID === element.guid)

                if(itemIndex >= 0){
                    // If the item is already in our list - remove if it's not selected, otherwise leave
                    if (row.__isSelected === false) {
                        selectedItems.splice(itemIndex, 1);
                    }
                }
                else{
                    // Not in the current list, then add
                    if (row.__isSelected === true) {
                        var newItem = {};
                        newItem.object = this.getSelectedItemFromRow(row);
                        newItem.guid = this.getGuidFromRow(row);
                        selectedItems.push(newItem);
                    }
                }
            });

            if(selectedItems.length > 0){
                itemSelected = true;
            }

            this.setState({ buttonsDisabled: !itemSelected, selectedItems: selectedItems })
        }
    }

    getGuidFromRow(row) {
        alert(' Override in derived class');
    }

    // Default to use First Name and Last Name - override if needed. 
    getSelectedItemDetail(privacyOn, item) {

        // Anonymise if needed
        var userListItem = item.FirstName + ' ' + item.LastName;
        if (privacyOn === true) {
            userListItem = StringUtils.AnonymiseString(item.FirstName) + ' ' + StringUtils.AnonymiseString(item.LastName);
        }

        return userListItem;
    }

    // Default to use First Name and Last Name - override if needed. 
    getSelectedItemFromRow(row) {
        return { FirstName: row.FirstName, LastName: row.LastName };
    }

    getSearchPlaceholder = () => {
        var retVal = [];

        if (this.table !== null && this._table.current !== undefined && this._table.current !== null) {

            const columns = this._table.current.getColumns();
            if (columns !== undefined) {
                columns.forEach(item => {
                    if (item.isSearchable === true) {
                        retVal.push(item.title);
                    }
                })
            }
        }

        if (retVal.length > 0) {
            return StringUtils.format(CurrentLang().search_placeholder, [retVal.join(', ').toLowerCase()]);
        }

        return StringUtils.format(CurrentLang().search_placeholder, "");
    }

    privacyModeChangedCallback = (privacyOn) => {
        if (undefined === privacyOn) {
            // leave privacy unchanged and update...
            this.forceUpdate();
        }
        else {
            this.setState({ privacyOn: privacyOn });
        }
    }

    getTableAreaContent = () => {
        var searchPlaceholder = " " + this.getSearchPlaceholder();

        var mainTable = <></>;

        if (this.state.tableClassType !== undefined) {
            mainTable = React.createElement(this.state.tableClassType, {ref: this._table, 
                                                                        div_name: "idTable", 
                                                                        selectionChangedCallback: this.selectionChangedCallback, 
                                                                        cellClickCallback: this.cellClickCallback, 
                                                                        privacyModeChangedCallback: 
                                                                        this.privacyModeChangedCallback }, null)
        }

        var treaters = <div className="ml-3 mr-3" >
            <Row className="ui-bg">
                <Col lg="11" md="11" className="mb-2 mt-3">
                    <InputGroup className="mr-auto ml-auto" size={CurrentTheme().ControlSize}>
                        <Input type="text" autoComplete={AUTO_COMPLETE_OFF} onFocus={this.onFocus}
                            name="search"
                            className="fontAwesome-placeholder"
                            placeholder={searchPlaceholder}
                            innerRef={this._searchInput}
                            onChange={(e) => this.onSearchChange(`${e.target.value}`)}
                        />

                    </InputGroup>
                </Col>
                <Col lg="1" md="1" className="mb-2 mt-3">
                    <Button color="secondary" className="float-right top-bar-btn" onClick={this.onClearSearch} size={CurrentTheme().ControlSize} >
                        <i className="fas fa-list" ></i>
                    </Button>
                </Col>
            </Row>
            <Row className="ui-bg">
                <Col>
                    <div className="table-area mt-0">
                        <MagstimLoadingSpinner isLoading={this.state.isLoading} />
                        {mainTable}
                    </div>
                </Col>
            </Row>
        </div>;

        return treaters;
    }

    getAnalyticsButtons = () => {
        alert(' Override in derived class');
    }

    render() {

        return (
            <Wrapper className="ml-3 mr-3" tableHeight={this.state.tableHeight}>

                <Row className="ui-main">
                    <Col>
                        <Row>
                            <Col lg="8" md="12" className="mb-2">
                                <PatientInformationCard title={this.tableAreaTitle()} >
                                    {this.getTableAreaContent()}
                                </PatientInformationCard>
                            </Col>

                            <Col lg="4" md="12" className="mb-2" >
                                <PatientInformationCard title={this.buttonAreaTitle()} >
                                    <div id="top-align" className="w-100">

                                        <InputGroup>
                                            <Label>{this.state.buttonsDisabled ? this.searchSelectHelp() : this.searchAnalyticsHelp()}</Label>
                                            <Label>{this.getSelectedItemsDetails()}</Label>
                                            {this.getAnalyticsButtons()}
                                        </InputGroup>
                                    </div>
                                </PatientInformationCard>
                            </Col>
                        </Row>
                    </Col>
                </Row>

            </Wrapper>
        );
    }

    handleError(error) {
        console.log(error);
        if (this.props.handleError !== undefined) {
            this.props.handleError(error);
        }
    }
}

const Wrapper = styled(styledMagstimTabsWrapper)`

#top-align { 
	padding-top:30px; 
} 

#top-align .btn  {
	width: 100%;
	margin-bottom: 15px;
	margin-left:30px;
	margin-right:30px;
	box-shadow: 0px 2px 5px rgba(0,0,0,0.2);
}


#top-align label {
	width: 100%;
	margin-bottom: 15px;
	margin-left:30px;
	margin-right:30px;
}

.fontAwesome-placeholder {
    font-family: 'Montserrat', FontAwesome, sans-serif;
  }

`

export default MagstimAnalyticsSearchBase;